import {TKey} from '@/translations/i18n'
import {TeamGroup} from './types'

export const teamGroupToLabel = {
    referring_doctor: 'projects:team_referring_doctor',
    therapist: 'projects:team_therapist',
    almoner: 'projects:team_almoner',
    psychologist: 'projects:team_psychologist',
    doctor: 'commons:doctor',
    other: 'commons:other'
} as const satisfies Record<TeamGroup, TKey>
